global.platformURI = 'https://app-api.censioanalytics.com';
